(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-menu-drawer-search]');
    if (!trigger) return;

    event.preventDefault();

    const headerDrawer = trigger.closest('header-drawer');
    if (!headerDrawer) return;

    const searchModal = headerDrawer.querySelector('[data-menu-drawer-search-modal]');

    if (searchModal) searchModal.open();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  /* "New this season": builds the pill row from the panels and shows one panel at a time. Without JS the panels stack and every product still shows. */
  document.querySelectorAll('[data-rh-new]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const tabs = [...root.querySelectorAll('.rh-new__tab')];
    const pills = root.querySelector('[data-rh-new-pills]');
    const buttons = tabs.map((tab, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'rh-hp-pill';
      b.setAttribute('role', 'tab');
      b.innerHTML = '<span class="rh-hp-pill__label"></span>' + (i ? '<small class="rh-hp-pill__count"></small>' : '');
      b.firstChild.textContent = tab.dataset.rhTabLabel;
      if (i) b.lastChild.textContent = Number(tab.dataset.rhTabCount).toLocaleString('en-AU');
      b.addEventListener('click', () => show(i));
      pills.append(b);
      return b;
    });
    function show(n) {
      tabs.forEach((t, i) => { t.hidden = i !== n; buttons[i].setAttribute('aria-selected', i === n); buttons[i].classList.toggle('rh-hp-pill--on', i === n); });
    }
    show(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-trade-apply"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('invalid', function (e) {
    if (!e.target.closest || !e.target.closest('.rht-apply__form')) return;
    e.target.setAttribute('aria-invalid', 'true');
  }, true);

  document.addEventListener('input', function (e) {
    if (!e.target.closest || !e.target.closest('.rht-apply__form')) return;
    if (e.target.checkValidity()) e.target.setAttribute('aria-invalid', 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-trade-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rh-trade-sticky')) {
    customElements.define('rh-trade-sticky', class extends HTMLElement {
      connectedCallback() {
        this.offset = parseInt(this.dataset.offset, 10) || 0;
        const link = this.querySelector('a');
        const href = link ? link.getAttribute('href') : '';
        this.apply = document.getElementById(href && href.charAt(0) === '#' && href.length > 1 ? href.slice(1) : 'apply');
        this.onScroll = this.update.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      update() {
        let show = window.scrollY > this.offset;
        if (show && this.apply) {
          const rect = this.apply.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) show = false;
        }
        this.classList.toggle('is-visible', show);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
